import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { secretService } from '@/services/secret-service';
import type { Secret } from '@/types/core/secret';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { secretQueryKeys } from './query-keys';

/**
 * List secrets for a given tenant.
 * Note: Secrets API doesn't support pagination.
 */
export function useListSecrets(
  tenantId: UUID
): UseQueryResult<Secret[], Error> {
  return useQuery<Secret[], Error>({
    queryKey: secretQueryKeys.list(tenantId),
    queryFn: () => secretService.listSecrets(tenantId),
    enabled: !isEmptyUUID(tenantId),
  });
}
